import { render, staticRenderFns } from "./activityClosedLoop.vue?vue&type=template&id=ed4ebd76&scoped=true"
import script from "./activityClosedLoop.vue?vue&type=script&lang=js"
export * from "./activityClosedLoop.vue?vue&type=script&lang=js"
import style0 from "./activityClosedLoop.vue?vue&type=style&index=0&id=ed4ebd76&prod&lang=scss&scoped=true"
import style1 from "./activityClosedLoop.vue?vue&type=style&index=1&id=ed4ebd76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4ebd76",
  null
  
)

export default component.exports